export enum PeopleKeywordSources {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  ORGANIZATION = 'ORGANIZATION',
  TEST_SCORE = 'TEST_SCORE',
  AWARD = 'AWARD',
  WORK_HISTORY_DESCRIPTION = 'WORK_HISTORY_DESCRIPTION',
  PUBLICATION = 'PUBLICATION',
  SUMMARY = 'SUMMARY',
  PATENT = 'PATENT',
  VOLUNTEERING = 'VOLUNTEERING',
  HEADLINE = 'HEADLINE',
  EDUCATION_DESCRIPTION = 'EDUCATION_DESCRIPTION',
  COURSE = 'COURSE',
  PROJECTS = 'PROJECTS',
  SKILL = 'SKILL',
  LANGUAGE_SKILL = 'LANGUAGE_SKILL',
  CERTIFICATION = 'CERTIFICATION',
}

export const PeopleKeywordSourceLabels: Record<PeopleKeywordSources, string> = {
  [PeopleKeywordSources.FIRST_NAME]: 'First Name',
  [PeopleKeywordSources.LAST_NAME]: 'Last Name',
  [PeopleKeywordSources.ORGANIZATION]: 'Organization',
  [PeopleKeywordSources.TEST_SCORE]: 'Test Score',
  [PeopleKeywordSources.AWARD]: 'Award',
  [PeopleKeywordSources.WORK_HISTORY_DESCRIPTION]: 'Work History',
  [PeopleKeywordSources.PUBLICATION]: 'Publication',
  [PeopleKeywordSources.SUMMARY]: 'Summary',
  [PeopleKeywordSources.PATENT]: 'Patent',
  [PeopleKeywordSources.VOLUNTEERING]: 'Volunteering',
  [PeopleKeywordSources.HEADLINE]: 'Headline',
  [PeopleKeywordSources.EDUCATION_DESCRIPTION]: 'Education',
  [PeopleKeywordSources.COURSE]: 'Course',
  [PeopleKeywordSources.PROJECTS]: 'Projects',
  [PeopleKeywordSources.SKILL]: 'Skills',
  [PeopleKeywordSources.LANGUAGE_SKILL]: 'Language Skills',
  [PeopleKeywordSources.CERTIFICATION]: 'Certificates',
};

export const PEOPLE_KEYWORD_SOURCES_CUSTOM_SORT_ORDER: PeopleKeywordSources[] =
  [
    PeopleKeywordSources.FIRST_NAME,
    PeopleKeywordSources.LAST_NAME,
    PeopleKeywordSources.HEADLINE,
    PeopleKeywordSources.SUMMARY,
    PeopleKeywordSources.WORK_HISTORY_DESCRIPTION,
    PeopleKeywordSources.EDUCATION_DESCRIPTION,
    PeopleKeywordSources.VOLUNTEERING,
    PeopleKeywordSources.PUBLICATION,
    PeopleKeywordSources.COURSE,
    PeopleKeywordSources.AWARD,
    PeopleKeywordSources.PATENT,
    PeopleKeywordSources.TEST_SCORE,
    PeopleKeywordSources.ORGANIZATION,
    PeopleKeywordSources.PROJECTS,
    PeopleKeywordSources.SKILL,
    PeopleKeywordSources.LANGUAGE_SKILL,
    PeopleKeywordSources.CERTIFICATION,
  ];
